import { Box } from '@chakra-ui/react';
import React from 'react';

import { WidgetsContent, UUID } from 'features/chat/config/types/Message';

import { ChatMessageWidgets } from './Widgets';

type WidgetsMessageProps = {
  id: UUID;
  content: WidgetsContent;
};

export function WidgetsMessage({ id, content }: WidgetsMessageProps) {
  return (
    <Box id={id} width="100%" data-testid="chat-message-widgets">
      <ChatMessageWidgets widgets={content.widgets} />
    </Box>
  );
}
